import { ArmyListUnit, TypeRule, Nullable, TroopCarac, TypeLvl } from '@Models';
import { UnitCaracView } from './UnitCaracView';
import { OrganisationView } from './OrganisationView';

export class ArmyListUnitProfilV2View {
  item: ArmyListUnit;
  name: string;
  organisations: Array<OrganisationView>;
  unitId: number;
  carac: UnitCaracView;
  troops: Array<TroopProfilView>;
  modelRules: Array<ModelRuleView>;
  mount: Nullable<ArmyListUnitProfilV2View>;

  constructor(params: ArmyListUnitProfilV2ViewParams) {
    this.item = params.item;
    this.name = params.name;
    this.organisations = params.organisations;
    this.unitId = params.unitId;
    this.carac = params.carac;
    this.troops = params.troops;
    this.modelRules = params.modelRules;
    this.mount = params.mount;
  }
}

export type ArmyListUnitProfilV2ViewParams = {
  item: ArmyListUnit;
  name: string;
  organisations: Array<OrganisationView>;
  unitId: number;
  carac: UnitCaracView;
  troops: Array<TroopProfilView>;
  modelRules: Array<ModelRuleView>;
  mount: Nullable<ArmyListUnitProfilV2View>;
};

export class TroopProfilView {
  name: string;
  carac: TroopCarac;
  modelRules: Array<ModelRuleView>;

  constructor(params: TroopProfilViewParams) {
    this.name = params.name;
    this.carac = params.carac;
    this.modelRules = params.modelRules;
  }
}

export type TroopProfilViewParams = {
  name: string;
  carac: TroopCarac;
  modelRules: Array<ModelRuleView>;
};

export class ModelRuleView {
  id: string;
  name: string;
  description: string;
  type: TypeRule;
  isGlobal: boolean;
  isDefensive: boolean;
  checkable: boolean;
  checked: boolean;
  armyListUnitModelRuleId: Nullable<string>;

  constructor(params: ModelRuleViewParams) {
    this.id = params.id;
    this.name = params.name;
    this.description = params.description;
    this.type = params.type;
    this.checkable = params.checkable ?? false;
    this.checked = params.checked ?? false;
    this.armyListUnitModelRuleId = params.armyListUnitModelRuleId ?? null;
    this.isGlobal = params.typeLvl === TypeLvl.Global;
    this.isDefensive = params.typeLvl === TypeLvl.Defensive;
  }
}

export type ModelRuleViewParams = {
  id: string;
  name: string;
  description: string;
  typeLvl: TypeLvl;
  type: TypeRule;
  checkable?: boolean;
  checked?: boolean;
  armyListUnitModelRuleId?: Nullable<string>;
};
